export const formattedDateTime = (timeString) => {
  const zulu = new Date(timeString);
  return `${zulu.toLocaleDateString()} ${zulu.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

export const capitalize = (wordList) => {
  if (!wordList) {
    return "";
  }

  const upcase = (word) => `${word[0].toUpperCase()}${word.slice(1)}`;

  return wordList.trim().split(" ").map(upcase).join(" ");
};

export const formattedCost = (cost) => {
  if (!cost || cost === 0) {
    return "$0";
  }
  const costString = cost.toLocaleString().replace(/^0+/, "");
  return `$${costString}`;
};

export const paddNumber = (opts) => {
  const { digits, number } = opts;
  const numString = typeof number === String ? number : number.toString();
  if (numString.length >= digits) {
    return numString;
  }
  return paddNumber({ digits, number: `0${numString}` });
};

export const formatInputDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    // Because we get a month back from 0-11 add one.
    const month = paddNumber({ digits: 2, number: date.getUTCMonth() + 1 });
    const day = paddNumber({ digits: 2, number: date.getUTCDate() });
    return `${date.getUTCFullYear()}-${month}-${day}`;
  }
};

export const formatDates = (estimate) => {
  if (!estimate) {
    return "";
  }
  const started = estimate.businessStartedOn;
  if (estimate.businessStartedOn) {
    const formattedStart = new Date(started).toISOString().replace(/\.000/, "");
    return { ...estimate, ...{ businessStartedOn: formattedStart } };
  }
  return estimate;
};

export const formatPhone = (value) => {
  if (!value) {
    return "";
  }
  var x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  return !x[2] ? x[1] : "(" + x[1] + ")" + x[2] + (x[3] ? "-" + x[3] : "");
};

const capitalizeFirst = (word) => {
  if (!word) {
    return "";
  }
  const cap = word[0].toUpperCase();
  const capWord = `${cap}${word.slice(1)}`;
  return capWord;
};

export const initialCaps = (string) => {
  if (typeof string !== "string" || !string) {
    return "";
  }
  return string.split(" ").map(capitalizeFirst).join(" ");
};

export const formatZip = (zip) => {
  const isString = typeof zip === "string";
  const safeString = isString ? zip : zip.toString();
  const zipLength = safeString.length;
  if (zipLength >= 6) {
    const onlyNums = safeString.replace(/[\Wa-zA-z]/g, "");
    return `${onlyNums.slice(0, 5)}-${onlyNums.slice(5, 9)}`;
  }

  return safeString.replace(/[\Wa-zA-z]/g, "");
};
